var render, staticRenderFns
import script from "./DynamicLayout.vue?vue&type=script&lang=ts&"
export * from "./DynamicLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ac79f6",
  null
  
)

export default component.exports